<template>
  <v-col sm='12'>
    <v-row no-gutters>
      <v-col style='padding: 0 20px'>
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>brush</md-icon>
            </div>
            <h4 class="title">
              {{ $t("webChannel.appearanceSettings.title") }}
            </h4>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method='post'>
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <!-- Avatar -->
                  <div class="file-input img-circle" style='display: block; max-width: none;'>
                    <h5 class="card-title" style='text-align: center'>
                      Avatar
                    </h5>
                    <div class="image-container">
                      <v-img class="overlayContainer" :aspect-ratio='1' contain :src="canalWebData.botAvatarUrl">
                        <div class="overlay">
                          <div class="text">
                            <span style='text-decoration: underline;'>
                              {{ $t( "webChannel.appearanceSettings.subitems.change" ) }}
                            </span>
                            <v-icon small style='color: white;'>mdi-paperclip</v-icon>
                          </div>
                          <input
                            class="custom-fileinput"
                            type='file'
                            @change='checkFileSize($event, "validityAvatar"); updateFile($event, "avatar");'
                            name='circle'
                            style='cursor: pointer;'
                            id='avatarInput'
                          />
                        </div>
                      </v-img>
                    </div>
                    <span
                      class="messageAvatar"
                      style="text-align: center;"
                      v-bind:style="{ color: activeColor['validityAvatar'] }"
                    >
                      {{ $t("webChannel.appearanceSettings.subitems.maxFileSize") }}
                    </span>
                  </div>

                  <md-field style='margin-top: 30px;'>
                    <label>
                      {{ $t( "webChannel.appearanceSettings.subitems.headerColor" ) }}
                    </label>
                    <md-input v-model='canalWebData.headerColor'/>
                  </md-field>

                  <md-field>
                    <label>
                      {{ $t( "webChannel.appearanceSettings.subitems.botTextColor" ) }}
                    </label>
                    <md-input v-model='canalWebData.botTextColor'/>
                  </md-field>

                  <md-field>
                    <label>
                      {{ $t( "webChannel.appearanceSettings.subitems.userTextColor" ) }}
                    </label>
                    <md-input v-model='canalWebData.customerTextColor'/>
                  </md-field>
                </div>

                <!-- Logo -->
                <div class="md-layout-item md-size-50">
                  <div class="file-input img-circle" style='display: block; max-width: none;'>
                    <h5 class="card-title" style='text-align: center'>
                      Logo
                    </h5>
                    <div class="image-container">
                      <v-img class="overlayContainer" :aspect-ratio='1' contain :src="canalWebData.welcomeImageUrl">
                        <div class="overlay">
                          <div class="text">
                            <span style='text-decoration: underline;'>
                              {{ $t( "webChannel.appearanceSettings.subitems.change" ) }}
                            </span>
                            <v-icon small style='color: white;'>mdi-paperclip</v-icon>
                          </div>
                          <input
                            class="custom-fileinput"
                            type='file'
                            @change='checkFileSize($event, "validityLogo"); updateFile($event, "logo");'
                            name='circle' style='cursor: pointer;'
                            id='logoInput'
                          />
                        </div>
                      </v-img>
                    </div>
                    <span
                      class="messageLogo"
                      style='text-align: center;'
                      v-bind:style="{ color: activeColor['validityLogo'] }"
                    >
                      {{ $t("webChannel.appearanceSettings.subitems.maxFileSize") }}
                    </span>
                  </div>

                  <md-field style='margin-top: 30px'>
                    <label>
                      {{ $t( "webChannel.appearanceSettings.subitems.footerColor" ) }}
                    </label>
                    <md-input v-model='canalWebData.footerColor'/>
                  </md-field>
                  <md-field>
                    <label>
                      {{ $t( "webChannel.appearanceSettings.subitems.botTalkBalloonColor" ) }}
                    </label>
                    <md-input v-model='canalWebData.botTextBalloonColor'/>
                  </md-field>
                  <md-field>
                    <label> {{ $t( "webChannel.appearanceSettings.subitems.userTalkBalloonColor" ) }}</label>
                    <md-input v-model='canalWebData.customerTextBalloonColor'/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout">
                <div class="md-layout-item" style='margin: auto;'>
                  {{ $t( "webChannel.appearanceSettings.subitems.isDisplayedLogo" ) }}
                </div>
                <div
                  class="md-layout-item.md-form-label.md-size-15"
                  style='padding: 0; margin: auto;'
                  :class="{'text-success': canalWebData.isDisplayedLogo, 'text-danger': !canalWebData.isDisplayedLogo }"
                >
                  {{ canalWebData.isDisplayedLogo ? $t("commonWords.enabled") : $t("commonWords.disabled") }}
                </div>
                <div class="md-layout-item md-size-15">
                  <md-switch v-model='canalWebData.isDisplayedLogo'/>
                </div>
              </div>

              <div class="md-layout">
                <div class="md-layout-item" style='margin: auto;'>
                  {{ $t( "webChannel.appearanceSettings.subitems.isCustomizedFooter" ) }}
                </div>
                <div
                  class="md-layout-item md-form-label md-size-15"
                  style='padding: 0; margin: auto;'
                  :class="{'text-success': canalWebData.isCustomizedFooter, 'text-danger': !canalWebData.isCustomizedFooter }"
                >
                  {{ canalWebData.isCustomizedFooter ? $t("commonWords.enabled") : $t("commonWords.disabled") }}
                </div>
                <div class="md-layout-item md-size-15">
                  <md-switch v-model='canalWebData.isCustomizedFooter'/>
                </div>
              </div>

              <div class="md-layout" v-if='canalWebData.isCustomizedFooter'>
                <div class="md-layout-item" style='margin: auto;'>
                  <md-field>
                    <label>
                      {{ $t( "webChannel.appearanceSettings.subitems.customizedFooterText" ) }}
                    </label>
                    <md-input v-model='canalWebData.footerText'/>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>
        </md-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import axios from 'axios'
import { mapFields } from 'vuex-map-fields'
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    },
    canalWebId: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    isImageTooLarge () {
      return this.imageSize > 65 * 1024
    }
  },
  data () {
    return {
      file: null,
      activeColor: {
        validityAvatar: '',
        validityLogo: ''
      }
    }
  },
  methods: {

    checkFileSize (event, type) {
      const fileInput = event.target
      if (fileInput.files && fileInput.files[0]) {
        const fileSize = fileInput.files[0].size
        const maxSize = 65 * 1024

        if (fileSize > maxSize) {
          this.activeColor[type] = 'red'
          fileInput.value = ''
        }
      }

      setTimeout(() => {
        this.activeColor.validityAvatar = ''
        this.activeColor.validityLogo = ''
      }, 3000)
    },

    updateFile (files, name) {
      this.file = files.target.files[0]
      this.upload(this.file, name)
    },

    async upload (file, name) {
      if (file) {
        const result = await this.$axios.post(
          `/assistant-configs/${this.assistantId}/webchannel/${this.canalWebId}/upload-link`,
          {
            fileMimeType: file.type,
            name
          }
        )
        const fullmock = result.data
        const form = new FormData()

        const mock = fullmock.preSigned

        Object.entries(mock.fields).forEach(([k, v]) => {
          form.append(k, v)
        })
        form.append('file', file)

        try {
          const uploadResponse = await axios.post(mock.url, form)
          if (uploadResponse.status === 204) {
            if (name === 'avatar') {
              this.canalWebData.botAvatarUrl = `https://${mock.bucket}.s3.us-east-2.amazonaws.com/${mock.filePath}?` + new Date().getTime()
            } else {
              this.canalWebData.welcomeImageUrl = `https://${mock.bucket}.s3.us-east-2.amazonaws.com/${mock.filePath}?` + new Date().getTime()
            }
          }
        } catch (e) {
          // TODO: tratar o erro
        }
      }
    }
  }
}
</script>

<style scoped>
.custom-fileinput {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  opacity: 0;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: #9c27b070;
}
.overlayContainer:hover .overlay {
  opacity: 1;
}
.text {
  color: white;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  white-space: nowrap;
}

.messageAvatar,
.messageLogo {
  display: flex;
  justify-content: center;
  color: rgba(0,0,0,.6);
  line-height: 12px;
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 300;
}
</style>
